import type { HearingLossProfession } from '../../common/interfaces/hearingLoss';

export const getProfessionName = (profession: HearingLossProfession | undefined): string => {
    switch (profession) {
        case 'audiologist':
            return 'audioloog';
        case 'entSpecialist':
            return 'KNO-arts';
        default:
            return 'specialist';
    }
};
